import styled from 'styled-components';
import { ILabel, ISwitcher } from '.';

export const Label = styled.label<ILabel>`
    display: block;
    padding: 0 0 0 44px;
    cursor: pointer;
    color: #666;

    &:before {
        content: '';
        position: absolute;
        top: 5px;
        left: 0;
        width: 36px;
        height: 15px;
        background-color: rgba(0, 0, 0, 0.26);
        border-radius: 14px;
        z-index: 1;
        transition: background-color 0.28s cubic-bezier(0.4, 0, 0.2, 1);
    }

    &:after {
        content: '';
        position: absolute;
        top: 2px;
        left: 0;
        width: 20px;
        height: 20px;
        background-color: #fff;
        border-radius: 14px;
        box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14),
            0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 1px 5px 0 rgba(0, 0, 0, 0.12);
        z-index: 2;
        transition: all 0.28s cubic-bezier(0.4, 0, 0.2, 1);
        transition-property: left, background-color;
    }
`;

export const Switcher = styled.input.attrs({
    type: 'checkbox',
})<ISwitcher>`
    position: absolute;
    top: 0;
    left: 0;
    width: 36px;
    height: 20px;
    opacity: 0;
    z-index: 0;
`;

export const Container = styled.div<{ color: string }>`
    display: inline-block;
    position: relative;
    font-size: 15px;
    line-height: 24px;

    input:checked + label {
        &:before {
            background-color: ${(props) => `${props.color}a1`};
        }

        &:after {
            left: 16px;
            background-color: ${(props) => props.color};
        }
    }
`;
